import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=097bbb10&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=097bbb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097bbb10",
  null
  
)

export default component.exports